import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGithub = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.994 0a6.99 6.99 0 0 1 2.233 13.615c-.235 0-.222-.139-.235-.28v-1.757a1.996 1.996 0 0 0-.596-1.422c2.204-.387 3.125-1.73 3.125-3.327 0-.775-.257-1.491-.763-2.066.3-.932-.04-1.722-.086-1.844-.844-.077-1.72.551-1.896.685a6.797 6.797 0 0 0-1.773-.216 6.79 6.79 0 0 0-1.764.212c-.073-.058-1.017-.79-1.925-.708-.046.12-.395.93-.077 1.875a3.078 3.078 0 0 0-.755 2.058c0 1.594.917 2.935 3.114 3.328a1.971 1.971 0 0 0-.543.95c-.408.101-1.213.204-1.625-.407-.57-.842-1.062-1.152-1.545-.904-.203.234.476.36.763.85.143.234.229 1.638 2.35 1.39v1.21c0 .178.055.439-.311.347A6.996 6.996 0 0 1 0 6.987C0 3.127 3.13-.002 6.994 0Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgGithub);
export { ForwardRef as ReactComponent };
